'use strict';
module.exports = ['$scope', '$uibModalInstance', 'params'
            , function ($scope, $uibModalInstance, params) {
                $scope.headerMessage=params.headerMessage;
                $scope.bodyMessage=params.bodyMessage;
                $scope.showCancelButton=params.showCancelButton;
                $scope.showNoButton=params.showNoButton;
                $scope.showYesButton=params.showYesButton;
                $scope.cancelButtonText=params.cancelButtonText;
                $scope.noButtonText=params.noButtonText;
                $scope.yesButtonText=params.yesButtonText;
                
                $scope.cancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };
                $scope.no = function () {
                    $uibModalInstance.dismiss('no');
                };
                $scope.yes = function () {
                     $uibModalInstance.close();
                };
            }];





//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-AstralSituationRecord/components/modal/modalQuestCtrl.js
// module id = 242
// module chunks = 0